import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { InvoiceStatus } from '@/features/Profile/sections/Invoices/api';
import { STATUS_COLOR } from '@/features/Profile/sections/Invoices/components/InvoiceStatusBadge/InvoiceStatusBadge.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 40px 50px 50px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 15px;
`;

export const Title = styled(Typography.Header).attrs({ $variant: '3' })`
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 22px;
    font-weight: 700;
  }
`;

export const CloseButton = styled(CloseIcon).attrs(({ theme }) => ({
  fill: theme.palette.secondary.labels,
}))`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

export const StatusLine = styled.div`
  text-align: center;
  margin-bottom: 25px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 30px;
  }
`;

export const StatusMeta = styled(Typography.Body).attrs({ as: 'span' })<{
  $status: InvoiceStatus;
}>`
  font-weight: 400;
  color: ${({ theme, $status }) => STATUS_COLOR[$status](theme)};
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
`;

export const Label = styled(Typography.Body)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body)`
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: right;
`;

export const Divider = styled.div`
  height: 1px;
  margin: 4px 0;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const TotalLabel = styled(Typography.Body)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const TotalValue = styled(Typography.Body)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
